var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultMemberImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6DCFE"
    },
    d: "M4.511,38.5c0.263-6.11,5.315-11,11.489-11h8c6.174,0,11.227,4.89,11.489,11H4.511z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M24,28c5.729,0,10.448,4.401,10.955,10l-29.91,0C5.552,32.401,10.271,28,16,28H24 M24,27h-8    C9.373,27,4,32.373,4,39v0h32v0C36,32.373,30.627,27,24,27L24,27z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M20,30.5c-3.219,0-4.309-2.101-4.5-2.536V22.5h9v5.464C24.312,28.394,23.223,30.5,20,30.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M24,23v4.855C23.759,28.343,22.738,30,20,30c-2.73,0-3.756-1.657-4-2.147V23H24 M25,22H15v6.062    c0,0,1.066,2.938,5,2.938s5-2.938,5-2.938V22L25,22z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFF0FE"
    },
    d: "M27.143,19.214c-1.3,0-2.356-1.058-2.356-2.357s1.057-2.357,2.356-2.357    c1.963,0,2.357,0.538,2.357,1.405C29.5,17.319,28.335,19.214,27.143,19.214z M12.857,19.214c-1.192,0-2.357-1.895-2.357-3.31    c0-0.867,0.395-1.405,2.357-1.405c1.3,0,2.356,1.057,2.356,2.357S14.157,19.214,12.857,19.214z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M27.143,15C29,15,29,15.481,29,15.905c0,1.234-1.041,2.81-1.857,2.81    c-1.024,0-1.857-0.833-1.857-1.857C25.286,15.833,26.119,15,27.143,15 M12.857,15c1.024,0,1.857,0.833,1.857,1.857    c0,1.024-0.833,1.857-1.857,1.857c-0.816,0-1.857-1.575-1.857-2.81C11,15.481,11,15,12.857,15 M27.143,14    c-1.578,0-2.857,1.279-2.857,2.857s1.279,2.857,2.857,2.857c1.578,0,2.857-2.232,2.857-3.81C30,14.327,28.721,14,27.143,14    L27.143,14z M12.857,14C11.279,14,10,14.327,10,15.905c0,1.578,1.279,3.81,2.857,3.81c1.578,0,2.857-1.279,2.857-2.857    S14.435,14,12.857,14L12.857,14z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M20,26.5c-0.604,0-1.172-0.218-1.642-0.63l-0.091-0.08l-0.116-0.03    C14.824,24.916,12.5,21.93,12.5,18.5V9.202c0-1.827,1.486-3.313,3.312-3.313h8.375c1.826,0,3.313,1.486,3.313,3.313V18.5    c0,3.43-2.324,6.416-5.651,7.26l-0.116,0.03l-0.091,0.08C21.172,26.282,20.604,26.5,20,26.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M24.187,6.389C25.738,6.389,27,7.651,27,9.202V18.5c0,3.201-2.169,5.987-5.275,6.776l-0.233,0.059    l-0.181,0.159C21.048,25.725,20.608,26,20,26s-1.048-0.275-1.311-0.506l-0.181-0.159l-0.233-0.059    C15.169,24.487,13,21.701,13,18.5V9.202c0-1.551,1.262-2.813,2.813-2.813H24.187 M24.187,5.389h-8.375    C13.707,5.389,12,7.096,12,9.202V18.5c0,3.737,2.566,6.866,6.029,7.745C18.557,26.709,19.242,27,20,27s1.443-0.291,1.971-0.755    C25.434,25.366,28,22.237,28,18.5V9.202C28,7.096,26.293,5.389,24.187,5.389L24.187,5.389z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6DCFE"
    },
    d: "M27.5,17.5V14c0-3.636-3.033-5.582-3.163-5.663l-0.398-0.25L23.664,8.47   c-0.085,0.118-2.119,2.887-6.514,2.887c-1.15,0-4.65,0-4.65,3.643v2.5h-0.179c-0.436-0.982-1.821-4.332-1.821-7.188   c0-5.271,3.617-8.812,9-8.812c3.839,0,4.992,2.585,5.039,2.695l0.131,0.303L25,4.5c1.671,0,4.5,1.162,4.5,5.515   c0,2.623-1.407,6.393-1.838,7.485H27.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M19.5,2c3.483,0,4.538,2.297,4.577,2.385L24.334,5H25c1.845,0,4,1.313,4,5.015    c0,1.536-0.507,3.498-1,5.043V14c0-3.909-3.258-5.999-3.397-6.087L23.802,7.41l-0.547,0.772c-0.019,0.027-1.941,2.674-6.105,2.674    C13.733,10.857,12,12.251,12,15v0.314c-0.491-1.422-1-3.305-1-5.003C11,5.34,14.416,2,19.5,2 M19.5,1C13.681,1,10,4.981,10,10.311    C10,13.842,12,18,12,18h1c0,0,0-2.029,0-3c0-2.668,2.024-3.143,4.15-3.143c4.73,0,6.922-3.097,6.922-3.097S27,10.599,27,14    c0,1.069,0,4,0,4h1c0,0,2-4.768,2-7.985C30,5.498,27.123,4,25,4C25,4,23.747,1,19.5,1L19.5,1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultMemberImage);
export default __webpack_public_path__ + "static/media/DefaultMemberImage.7ea0019e814ab95360c7506efdaa2fda.svg";
export { ForwardRef as ReactComponent };